export const displayPercentage = (decimalPercentage, displaySymbol = true) => {
    if (displaySymbol) {
        return (decimalPercentage * 100.0).toLocaleString(undefined, { maximumFractionDigits: 1 }) + "%";
    }
    return (decimalPercentage * 100.0).toLocaleString(undefined, { maximumFractionDigits: 1 });
};
